import React from 'react';
import { motion } from 'framer-motion';

/** Wraps a page with an enter/exit motion, driven by AnimatePresence in App.js */
const PageTransition = ({ children }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -12 }}
    transition={{ duration: 0.45, ease: [0.22, 0.61, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export default PageTransition;
